import { Button, FormInstance, Popover, Typography } from 'antd';
import { ColumnsType } from 'antd/lib/table';
import { useTranslation } from 'react-i18next';
import { onExportToExcel } from '../../table/TableExport';
import { useState } from 'react';
import { alertMessage } from '../../../utils/alertMessage';
import getDashboardStyle from '../../../utils/getDashboardStyle';

type BatchContactTableFooterToolbarProps = {
  form: FormInstance<any>;
  columns?: ColumnsType<any>;
  selectedRows: any[];
  selectedRowKeys?: any[];
  setSelectedRowKeys?: React.Dispatch<React.SetStateAction<React.Key[]>>;
  funct: {
    refresh?: Function;
    deleteFunc?: () => void;
    exportConfig?: { fileName: string; url?: string };
  };
};

const BatchContactTableFooterToolbar = ({
  form,
  columns,
  selectedRows,
  selectedRowKeys,
  setSelectedRowKeys,
  funct,
}: BatchContactTableFooterToolbarProps) => {
  //General Components
  const { t } = useTranslation();
  //Visible/Statuses Components
  const [deleteFunctVisible, setDeleteFunctVisible] = useState(false);

  const sendMailFromGmail = () => {
    const emailTo: string[] = []; // 收件人
    const emailCc: string[] = [];

    const validRows = selectedRows.filter((row) => !!row.email);
    const hasDefault = validRows.some((row) => row.isDefault === true);

    if (hasDefault) {
      validRows.forEach((row) => {
        if (row.isDefault === true) {
          emailTo.push(row.email);
        } else {
          emailCc.push(row.email);
        }
      });
    } else if (validRows.length > 0) {
      // 没有 isDefault true 的，取第一个作为主收件人
      emailTo.push(validRows[0].email);
      emailCc.push(...validRows.slice(1).map((row) => row.email));
    }

    if (emailTo.length === 0) {
      alertMessage('error', t('general.inputError.pleaseSelectOne'));
      return;
    }

    const bodyContent = `
Hi,

Please find the attachments.

Should you have any questions or require further clarification, feel free to reach out.

Best regards,
${getDashboardStyle().emailTitle}
    `;
    const subject = encodeURIComponent(`${getDashboardStyle().emailTitle}`);
    const body = encodeURIComponent(bodyContent.trim());
    const gmailUrl = `https://mail.google.com/mail/?view=cm&fs=1&to=${emailTo}&cc=${emailCc}&su=${subject}&body=${body}`;

    window.open(gmailUrl, '_blank');
  };

  return (
    <>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-start',
        }}
      >
        <Button
          type="link"
          onClick={sendMailFromGmail}
          style={{ textAlign: 'left' }}
        >
          {t('actionsColumn.sendEmail')}
        </Button>
        {selectedRows && columns && funct.exportConfig && (
          <Button
            block
            type="text"
            onClick={() => {
              onExportToExcel(columns, selectedRows, funct.exportConfig);
            }}
            style={{ textAlign: 'left' }}
          >
            {t('actionsColumn.exportSelected')}
          </Button>
        )}
        {funct.deleteFunc && (
          <Popover
            overlayStyle={{ width: 195 }}
            placement="rightTop"
            trigger={'click'}
            getPopupContainer={(triggerNode) =>
              triggerNode.parentNode as HTMLElement
            }
            visible={deleteFunctVisible}
            content={
              <div
                style={{
                  padding: 10,
                  display: 'flex',
                  flexDirection: 'column',
                }}
              >
                <Typography.Text style={{ fontWeight: 500 }}>
                  {t('actionsColumn.groupDeleteWarning')}
                </Typography.Text>
                <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                  <Button
                    size="small"
                    onClick={() => setDeleteFunctVisible(false)}
                  >
                    {t('actionsColumn.confirmation.no')}
                  </Button>
                  <Button
                    type="primary"
                    size="small"
                    style={{ marginLeft: 5 }}
                    onClick={() => {
                      funct && funct.deleteFunc && funct.deleteFunc();
                      setDeleteFunctVisible(false);
                    }}
                  >
                    {t('actionsColumn.confirmation.yes')}
                  </Button>
                </div>
              </div>
            }
          >
            <Button
              type="text"
              danger
              onClick={() => setDeleteFunctVisible(true)}
              block
              style={{ textAlign: 'left' }}
            >
              {t('actionsColumn.groupDelete')}
            </Button>
          </Popover>
        )}
      </div>
    </>
  );
};

export default BatchContactTableFooterToolbar;
